import { Course, Product } from '@/src/types';

export const INITIAL_COURSES: Course[] = [
  {
    id: 'course-hindustani-vocal',
    slug: 'hindustani-classical-vocal',
    title: 'Hindustani Classical Vocal',
    instrument: 'vocals',
    category: 'Indian Classical',
    tagline: 'Raag, swara, and the sacred discipline of the North Indian vocal tradition.',
    description: 'A 1:1 master apprentice journey through voice cultivation, Kharaj riyaaz (lower octave training), swar sthana accuracy, and foundational Raags including Yaman, Bhairav, and Bilawal. Learn alankars, bandishes, and improvisational taans under patient expert mentorship.',
    level: 'All Levels',
    ageGroup: 'Kids (6+), Teens & Adults',
    sessionsPerWeek: 2,
    sessionLengthMinutes: 45,
    priceMonthly: 120,
    currency: 'USD',
    imageUrl: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&w=1000&q=80',
    curriculum: [
      'Voice placement, breath anchoring & Kharaj riyaaz',
      'Solfège Swara system: Sa, Re, Ga, Ma, Pa, Dha, Ni',
      'Raag Yaman: Aroha, Avroha, Pakad & Chhota Khayal',
      'Teentaal & Ektaal rhythmic cycles and Tihais',
      'Aalap improvisation, bol-taans & ornamentation (Meend)'
    ],
    featured: true,
    teacher: {
      name: 'Vidushi Sunanda Sharma',
      title: 'Senior Vocalist & Sangeet Shiromani',
      avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=300&q=80',
      bio: 'Over 22 years of concert experience and pedagogical excellence in the Kirana and Banaras gharanas.'
    }
  },
  {
    id: 'course-piano-keyboard',
    slug: 'piano-and-keyboard',
    title: 'Classical & Contemporary Piano',
    instrument: 'piano',
    category: 'Keys & Harmony',
    tagline: 'From foundational hand anatomy and reading to expressive repertoire.',
    description: 'Experience 1:1 instruction crafted for your specific mechanical posture, sight-reading goals, and harmonic depth. Journey from two-hand coordination, major/minor arpeggios, and Bach/Chopin preludes to modern jazz chord voicings and lead sheet improvisation.',
    level: 'All Levels',
    ageGroup: 'Kids (5+), Teens & Adults',
    sessionsPerWeek: 2,
    sessionLengthMinutes: 45,
    priceMonthly: 135,
    currency: 'USD',
    imageUrl: 'https://images.unsplash.com/photo-1520523839898-50712825e3a7?auto=format&fit=crop&w=1000&q=80',
    curriculum: [
      'Ergonomic wrist poise, finger independence & posture',
      'Grand staff sight reading & rhythmic solfège',
      'Chord inversions, voice leading & cadence harmony',
      'Classical sonatinas & contemporary film themes',
      'Dynamic pedal artistry & rubato interpretation'
    ],
    featured: true,
    teacher: {
      name: 'Julian Sterling, M.Mus.',
      title: 'Concert Pianist & Conservatory Fellow',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=300&q=80',
      bio: 'Trained at London Royal College of Music, mentoring learners across the UK, Americas, and Asia.'
    }
  },
  {
    id: 'course-acoustic-guitar',
    slug: 'acoustic-and-classical-guitar',
    title: 'Acoustic & Classical Guitar',
    instrument: 'guitar',
    category: 'Strings & Frets',
    tagline: 'Fingertip precision, chord geometry, and soulful fingerstyle playing.',
    description: 'Whether your passion is acoustic fingerpicking, classical Spanish nylon-string polyphony, or contemporary songcraft, our live 1:1 sessions coach your left-hand tension release, right-hand thumb/index alternating strokes, and rhythmic groove.',
    level: 'All Levels',
    ageGroup: 'Kids (8+), Teens & Adults',
    sessionsPerWeek: 2,
    sessionLengthMinutes: 45,
    priceMonthly: 125,
    currency: 'USD',
    imageUrl: 'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?auto=format&fit=crop&w=1000&q=80',
    curriculum: [
      'Proper thumb positioning, fret contact & barring without pain',
      'Open chords, transition drills & folk/pop strumming',
      'Travis picking & classical P-I-M-A fingerstyle',
      'Pentatonic & major scale shapes across all 6 strings',
      'Transposition, capo strategies & ear transcription'
    ],
    featured: true,
    teacher: {
      name: 'Arjun Nambiar',
      title: 'Acoustic Guitarist & Session Arranger',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=300&q=80',
      bio: 'Over 14 years performing worldwide with acoustic ensembles and coaching hundreds of fingerstyle players.'
    }
  },
  {
    id: 'course-tabla-percussion',
    slug: 'tabla-and-rhythm-mastery',
    title: 'Tabla & Rhythm Mastery',
    instrument: 'tabla',
    category: 'Rhythm & Percussion',
    tagline: 'The timeless language of Bols, Bayan resonance, and rhythmic precision.',
    description: 'Master the intricate, vocalized percussion tradition of the Subcontinent. Learn crystalline bols (Dha, Dhin, Ge, Na, Tin, Ta), Bayan modulations (meend pitch bends), and rhythmic structures across Teentaal, Keherwa, Roopak, and Jhaptal.',
    level: 'All Levels',
    ageGroup: 'Kids (7+), Teens & Adults',
    sessionsPerWeek: 2,
    sessionLengthMinutes: 45,
    priceMonthly: 125,
    currency: 'USD',
    imageUrl: 'https://images.unsplash.com/photo-1511192336575-5a79af67a629?auto=format&fit=crop&w=1000&q=80',
    curriculum: [
      'Hand anatomy on Syahi, Maidan, and Kinar',
      'Clapping and reciting Bols with Padhant recitation',
      'Teentaal 16-beat cycle: Theka, Kayadas & Relas',
      'Bayan left-hand pressure glide techniques',
      'Tihai construction mathematics and speed drills'
    ],
    featured: true,
    teacher: {
      name: 'Ustad Tariq Rehmat',
      title: 'Senior Tabla Maestro (Punjab & Delhi Ang)',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=300&q=80',
      bio: 'Celebrated accompanist to world-class vocalists and instrumentalists with 25 years teaching expertise.'
    }
  },
  {
    id: 'course-western-vocal',
    slug: 'contemporary-western-vocals',
    title: 'Contemporary & Pop Vocals',
    instrument: 'vocals',
    category: 'Western Vocal',
    tagline: 'Vocal safety, mixed voice resonance, and stage-ready dynamic presence.',
    description: 'Unleash your organic vocal power without strain. Discover diaphragmatic breath management, passagio navigation (smoothing the break between chest and head voice), vibrato control, and stylistic nuance across pop, indie, R&B, and musical theatre.',
    level: 'All Levels',
    ageGroup: 'Teens & Adults',
    sessionsPerWeek: 2,
    sessionLengthMinutes: 45,
    priceMonthly: 130,
    currency: 'USD',
    imageUrl: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1000&q=80',
    curriculum: [
      'Diaphragm support & tension-free appoggio posture',
      'Mix voice transitions & belt health techniques',
      'Microphone technique and studio monitors training',
      'Riffs, runs, dynamic nuance & emotive phrasing',
      'Audition preparation & live stage presence'
    ],
    featured: false,
    teacher: {
      name: 'Elena Rostova',
      title: 'Vocal Coach & Studio Vocalist',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=300&q=80',
      bio: 'Berklee College of Music alumna having coached major recording artists and West End performers.'
    }
  },
  {
    id: 'course-carnatic-vocal',
    slug: 'carnatic-classical-vocal',
    title: 'Carnatic Classical Vocal',
    instrument: 'vocals',
    category: 'South Indian Classical',
    tagline: 'Varnams, Kritis, and the mathematical beauty of Tala & Gamaka.',
    description: 'Delve into the pristine structure of South Indian classical singing. Progress systematically from Sarali and Janta Varisais to Alankarams, Geethams, Varnams, and timeless Kritis of the Trinity (Tyagaraja, Muthuswami Dikshitar, Syama Sastri).',
    level: 'All Levels',
    ageGroup: 'Kids (6+), Teens & Adults',
    sessionsPerWeek: 2,
    sessionLengthMinutes: 45,
    priceMonthly: 120,
    currency: 'USD',
    imageUrl: 'https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=1000&q=80',
    curriculum: [
      'Shruti alignment with electronic Tanpura',
      'Sarali, Janta, and Dhattu Varisai speed challenges',
      'Sapta Talas: Adi, Rupaka, Misra Chapu rhythms',
      'Gamaka oscillation mastery (Kampita, Nokku, Pratyagatam)',
      'Varnam memorization & Manodharma introduction'
    ],
    featured: false,
    teacher: {
      name: 'Dr. Radhika Ramanathan',
      title: 'Carnatic Vidwan & Musicologist',
      avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=300&q=80',
      bio: 'A-Grade All India Radio artist with a doctorate in Carnatic microtonal aesthetics.'
    }
  }
];

export const INITIAL_PRODUCTS: Product[] = [
  // 📚 DIGITAL PRODUCTS (Ebooks & Practice Resources)
  {
    id: 'prod-hindustani-vocal-guide',
    name: 'Hindustani Classical Vocal Essentials: The Complete Swara & Riyaaz Guide',
    title: 'Hindustani Classical Vocal Essentials: The Complete Swara & Riyaaz Guide',
    slug: 'hindustani-classical-vocal-essentials',
    type: 'digital',
    productType: 'DIGITAL_PRODUCT',
    category: 'ebooks',
    price: 499,
    originalPrice: 999,
    salePrice: 499,
    displayPrice: 499,
    currency: 'INR',
    description: 'Comprehensive digital master guide covering Kharaj Riyaaz vocal technique, Swara identification drills, 10 Thaats fundamentals, and daily 30-minute structured warmup regimens.',
    shortDescription: 'Master Indian classical vocal technique, Kharaj riyaaz, Swara placement, and daily voice culture.',
    fullDescription: 'Designed by senior classical gurus at Saremi Academy, this digital guide provides step-by-step guidance for developing vocal stamina, accurate microtonal pitch (shruti), and ornamentations (meend, murki, gamak). Includes detailed notation charts, warmup checklists, and companion audio stems for tanpura pitch matching.',
    fileFormat: 'Digital PDF Ebook (68 Pages) + Audio Companion',
    digitalDownloadUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-hindustani-vocal-essentials.pdf',
    digitalFileUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-hindustani-vocal-essentials.pdf',
    previewUrl: 'https://storage.googleapis.com/saremi-assets/previews/hindustani-vocal-preview.pdf',
    whatYoullLearn: [
      'Kharaj Riyaaz: Deep morning lower-octave vocal resonance exercises',
      'The 10 Classical Thaats (Bilawal, Kalyan, Khamaj, Kafi, Bhairav, etc.)',
      'Swara Sadhana & Alankars across 3 octaves (Mandra, Madhya, Taar Saptak)',
      'Breath support mechanics: Diaphragmatic stabilization without throat strain',
      'Daily 30-minute structured practice schedules for all vocal ranges'
    ],
    whoItsFor: [
      'Beginner to intermediate vocalists wanting disciplined classical foundations',
      'Playback, ghazal, and bhajan singers seeking pure pitch intonation',
      'Music students preparing for graded board certifications & exams'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=800&q=80',
    badge: 'Bestselling Ebook',
    rating: 4.9,
    reviewsCount: 128,
    isPublished: true,
    isFeatured: true,
    createdAt: '2026-01-10T00:00:00.000Z'
  },
  {
    id: 'prod-acoustic-guitar-guide',
    name: 'The Modern Acoustic Guitarist: Chord Voicings & Fingerstyle Technique',
    title: 'The Modern Acoustic Guitarist: Chord Voicings & Fingerstyle Technique',
    slug: 'modern-acoustic-guitarist-guide',
    type: 'digital',
    productType: 'DIGITAL_PRODUCT',
    category: 'ebooks',
    price: 599,
    originalPrice: 1199,
    salePrice: 599,
    displayPrice: 599,
    currency: 'INR',
    description: 'A complete practical method book for acoustic guitarists: open chord inversions, barre chord fluidity, Travis picking, rhythmic strumming, and pentatonic soloing.',
    shortDescription: 'From essential chord transitions to expressive fingerpicking arpeggios and rhythmic accompaniment.',
    fullDescription: 'Whether you are playing your first chords or moving beyond basic open shapes, this ebook systematically unlocks the fretboard. Learn ergonomic hand positioning to avoid wrist strain, master quick barre chord changes, and explore contemporary fingerstyle techniques with clear tablature and fretboard diagrams.',
    fileFormat: 'Digital PDF Ebook (74 Pages) with Tablatures & Diagrams',
    digitalDownloadUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-acoustic-guitar-guide.pdf',
    digitalFileUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-acoustic-guitar-guide.pdf',
    previewUrl: 'https://storage.googleapis.com/saremi-assets/previews/guitar-guide-preview.pdf',
    whatYoullLearn: [
      'Ergonomic left-hand thumb placement and buzz-free barre chords',
      'The CAGED chord system & open string triad inversions',
      'Travis picking & syncopated acoustic fingerstyle patterns',
      'Major & Minor Pentatonic scale boxes for melodic improvisation',
      'Dynamic strumming patterns with accented backbeats and percussive slaps'
    ],
    whoItsFor: [
      'Acoustic and electric guitar beginners wanting structured progress',
      'Songwriters needing richer chord voicings beyond standard open chords',
      'Singers wanting reliable, self-accompanied fingerstyle technique'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1525201548942-d8732f6617a0?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1525201548942-d8732f6617a0?auto=format&fit=crop&w=800&q=80',
    badge: 'Popular Guide',
    rating: 4.8,
    reviewsCount: 94,
    isPublished: true,
    isFeatured: true,
    createdAt: '2026-01-12T00:00:00.000Z'
  },
  {
    id: 'prod-piano-sight-reading',
    name: 'Western Classical Piano: Sight-Reading & Technique Foundation',
    title: 'Western Classical Piano: Sight-Reading & Technique Foundation',
    slug: 'western-classical-piano-technique',
    type: 'digital',
    productType: 'DIGITAL_PRODUCT',
    category: 'ebooks',
    price: 549,
    originalPrice: 1099,
    salePrice: 549,
    displayPrice: 549,
    currency: 'INR',
    description: 'Master Treble and Bass clef sight-reading, hand independence drills, major & harmonic minor scales with fingering, and musical dynamics.',
    shortDescription: 'Build rock-solid keyboard sight-reading, hand coordination, and classical finger technique.',
    fullDescription: 'Designed for beginners and keyboardists seeking formal sight-reading fluency. Featuring progressive dual-clef exercises, finger dexterity drills from Hanon adapted for modern learners, and pedagogical tips on pedal technique and expressive phrasing.',
    fileFormat: 'Digital PDF Ebook (60 Pages) with High-Res Sheet Music',
    digitalDownloadUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-piano-sight-reading.pdf',
    digitalFileUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-piano-sight-reading.pdf',
    whatYoullLearn: [
      'Rapid Treble & Bass clef note identification without mnemonics',
      'Two-handed rhythmic independence and polyrhythm coordination',
      'Standard scale fingering (all 12 Major & Natural/Harmonic Minor keys)',
      'Arpeggios, broken chords, and smooth legato wrist transitions',
      'Articulations: Staccato, tenuto, accent marks, and sustain pedaling'
    ],
    whoItsFor: [
      'Piano students preparing for Trinity, ABRSM, or LCM initial grades',
      'Music producers and synth players wanting genuine keyboard fluency',
      'Self-taught pianists who struggle with two-handed coordination'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1520523839898-5071282543e1?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1520523839898-5071282543e1?auto=format&fit=crop&w=800&q=80',
    badge: 'Top Rated',
    rating: 4.9,
    reviewsCount: 86,
    isPublished: true,
    isFeatured: false,
    createdAt: '2026-01-15T00:00:00.000Z'
  },
  {
    id: 'prod-tabla-teentaal-guide',
    name: 'Teentaal & Bols Masterclass: Tabla Rhythm Theory & Kayada Companion',
    title: 'Teentaal & Bols Masterclass: Tabla Rhythm Theory & Kayada Companion',
    slug: 'teentaal-bols-masterclass-tabla',
    type: 'digital',
    productType: 'DIGITAL_PRODUCT',
    category: 'ebooks',
    price: 449,
    originalPrice: 899,
    salePrice: 449,
    displayPrice: 449,
    currency: 'INR',
    description: 'Crystalline pronunciation of Bols (Dha, Dhin, Ge, Na, Tin, Ta), Teentaal 16-beat cycle mapping, Kayada variations, and Tihai mathematics.',
    shortDescription: 'The definitive handbook to Indian percussion bols, padhant recitation, and rhythmic compositions.',
    fullDescription: 'Unlock the profound rhythmic universe of Indian classical music. This ebook breaks down hand stroke geometry on the Syahi, Maidan, and Kinar, provides written notation for classic Punjab and Delhi Ang kayadas, and teaches the mathematical formulas for constructing impromptu Tihais.',
    fileFormat: 'Digital PDF Ebook (52 Pages) with Indian Bhatkhande Notation',
    digitalDownloadUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-tabla-teentaal-guide.pdf',
    digitalFileUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-tabla-teentaal-guide.pdf',
    whatYoullLearn: [
      'Proper hand placement on Dayan & Bayan for resonant tone',
      'Padhant: Reciting bols with metric clapping (Taali & Khaali)',
      'Teentaal 16-beat structure, Vilambit & Drut compositions',
      'Kayada, Palta, and Rela variation structuring',
      'The mathematical formula for calculating Tihais from any matra'
    ],
    whoItsFor: [
      'Tabla students from beginner to intermediate level',
      'Vocal and instrumental students wanting strong Laya & Taal command',
      'Western percussionists interested in Indian polyrhythms'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1511192336575-5a79af67a629?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1511192336575-5a79af67a629?auto=format&fit=crop&w=800&q=80',
    badge: 'Artisan Guide',
    rating: 5.0,
    reviewsCount: 67,
    isPublished: true,
    isFeatured: false,
    createdAt: '2026-01-18T00:00:00.000Z'
  },
  {
    id: 'prod-vocal-30day-tracker',
    name: '30-Day Vocal Improvement & Breath Control Workbook',
    title: '30-Day Vocal Improvement & Breath Control Workbook',
    slug: '30-day-vocal-improvement-workbook',
    type: 'digital',
    productType: 'DIGITAL_PRODUCT',
    category: 'practice_tools',
    price: 399,
    originalPrice: 799,
    salePrice: 399,
    displayPrice: 399,
    currency: 'INR',
    description: 'A 30-day daily guided workbook with diaphragmatic breathing logs, pitch accuracy checklists, and daily 20-minute guided routines.',
    shortDescription: 'Daily 20-minute voice workouts and habit tracker for steady range expansion and vocal stamina.',
    fullDescription: 'Consistency in riyaaz is the secret to vocal mastery. This workbook provides day-by-day structured practice sheets, target pitch logs, vocal health hygiene tips, and warmup tracks designed to expand your vocal range safely without straining your cords.',
    fileFormat: 'Digital PDF Ebook & Printable 30-Day Tracker (45 Pages)',
    digitalDownloadUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-30day-vocal-workbook.pdf',
    digitalFileUrl: 'https://storage.googleapis.com/saremi-assets/ebooks/saremi-30day-vocal-workbook.pdf',
    whatYoullLearn: [
      'Appoggio diaphragmatic breath support daily routines',
      'Gentle vocal chord sirens and semi-occluded vocal tract (SOVT) straw drills',
      'Daily 20-minute riyaaz schedules for morning and evening',
      'Objective self-assessment metrics for intonation and vibrato control',
      'Vocal health protocols: Hydration, warmup, cool-down, and strain prevention'
    ],
    whoItsFor: [
      'Singers who want daily practice accountability and structured habits',
      'Vocalists recovering from strain or wanting to build healthy stamina',
      'Anyone preparing for live performances, auditions, or recordings'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=800&q=80',
    badge: 'Essential Tool',
    rating: 4.9,
    reviewsCount: 142,
    isPublished: true,
    isFeatured: true,
    createdAt: '2026-01-20T00:00:00.000Z'
  },

  // 🎸 AFFILIATE PRODUCTS (Carefully Curated Gear on Amazon / Flipkart)
  {
    id: 'prod-gear-yamaha-f280',
    name: 'Yamaha F280 Acoustic Guitar (Natural)',
    title: 'Yamaha F280 Acoustic Guitar (Natural)',
    slug: 'yamaha-f280-acoustic-guitar',
    type: 'affiliate',
    productType: 'AFFILIATE_PRODUCT',
    brand: 'Yamaha',
    category: 'guitars',
    retailer: 'Amazon',
    affiliateUrl: 'https://www.amazon.in/dp/B07KKVNN5X',
    price: 7990,
    originalPrice: 9490,
    displayPrice: 7990,
    discountInfo: '16% off',
    currency: 'INR',
    shortDescription: 'The benchmark entry-level acoustic guitar recommended by music tutors for tone and comfortable action.',
    description: 'Yamaha F280 is widely acknowledged by music gurus as the benchmark entry-level acoustic guitar offering exceptional tuning stability, low comfortable string action, and resonant sound projection.',
    fullDescription: 'Built with a resonant spruce top and traditional Western body shape, the Yamaha F280 delivers a balanced acoustic voice with clear treble definition and warm lows. Its comfortable neck profile and smooth frets ensure effortless chord transitions for beginner and intermediate players.',
    keyFeatures: [
      'Spruce top for crisp, dynamic acoustic projection',
      'Rosewood fingerboard with comfortable low string action',
      'Durable die-cast chrome tuners with excellent pitch stability',
      'Full dreadnought body shape providing rich resonance'
    ],
    whyWeRecommendIt: 'The Yamaha F280 is the most dependable student acoustic guitar in India. Its low action prevents finger fatigue during early practice, and its tuning stability stands up to changing weather conditions.',
    suitableFor: [
      'Beginners starting their guitar journey',
      'Daily home riyaaz and practice sessions',
      'Acoustic fingerstyle and chord strumming accompaniment'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?auto=format&fit=crop&w=800&q=80',
    badge: 'Recommended for Beginners',
    rating: 4.8,
    reviewsCount: 3420,
    isPublished: true,
    isFeatured: true,
    isSaremiPick: true,
    createdAt: '2026-01-22T00:00:00.000Z'
  },
  {
    id: 'prod-gear-yamaha-keyboard',
    name: 'Yamaha PSR-E373 61-Key Portable Keyboard',
    title: 'Yamaha PSR-E373 61-Key Portable Keyboard',
    slug: 'yamaha-psr-e373-keyboard',
    type: 'affiliate',
    productType: 'AFFILIATE_PRODUCT',
    brand: 'Yamaha',
    category: 'keyboards',
    retailer: 'Amazon',
    affiliateUrl: 'https://www.amazon.in/dp/B08GS15MFF',
    price: 13490,
    originalPrice: 15990,
    displayPrice: 13490,
    discountInfo: '15% off',
    currency: 'INR',
    shortDescription: '61 touch-sensitive keys with 622 instrument voices and USB-to-Host connectivity.',
    description: 'Dynamic touch-sensitive keyboard essential for developing proper finger velocity control, expressive classical piano playing, and music theory visualization.',
    fullDescription: 'Featuring touch-sensitive keys and the newly developed LSI tone generator, the Yamaha PSR-E373 delivers stunningly realistic acoustic instrument voices including grand piano, harmonium, strings, and brass. Connect directly via USB to your computer for 1:1 online classes and MIDI recording.',
    keyFeatures: [
      '61 touch-sensitive keys responding dynamically to touch pressure',
      '622 high-quality voices including Super Articulation Lite voices',
      'USB-to-Host audio and MIDI for easy connection to laptops & tablets',
      'Built-in lesson functions (Keys to Success) and onboard effects'
    ],
    whyWeRecommendIt: 'Touch response is non-negotiable for students learning piano or keyboard. The PSR-E373 offers the best combination of expressive keys, rich acoustic voices, and reliable digital USB connection for live online lessons.',
    suitableFor: [
      'Beginner & intermediate piano and keyboard students',
      'Ear training, swara practice, and music theory study',
      'Home studio MIDI keyboard production'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&w=800&q=80',
    badge: 'Top Keyboard for Learning',
    rating: 4.9,
    reviewsCount: 1850,
    isPublished: true,
    isFeatured: true,
    isSaremiPick: true,
    createdAt: '2026-01-24T00:00:00.000Z'
  },
  {
    id: 'prod-gear-shure-sm58',
    name: 'Shure SM58 Cardioid Dynamic Vocal Microphone',
    title: 'Shure SM58 Cardioid Dynamic Vocal Microphone',
    slug: 'shure-sm58-vocal-microphone',
    type: 'affiliate',
    productType: 'AFFILIATE_PRODUCT',
    brand: 'Shure',
    category: 'microphones',
    retailer: 'Amazon',
    affiliateUrl: 'https://www.amazon.in/dp/B000CZ0R42',
    price: 9200,
    originalPrice: 11500,
    displayPrice: 9200,
    discountInfo: '20% off',
    currency: 'INR',
    shortDescription: 'The world benchmark vocal microphone: eliminates room noise and delivers warm, clear vocal tone.',
    description: 'The industry-standard cardioid dynamic microphone tailored to deliver warm, crystalline vocal reproduction while rejecting room reverberation and background noise.',
    fullDescription: 'The Shure SM58 is legendary for its durability, vocal clarity, and feedback rejection. Its cardioid pickup pattern isolates your voice from room echo and fan noise, ensuring your vocal coach hears every nuance of your pitch, breath, and diction during live 1:1 online classes and stage performances.',
    keyFeatures: [
      'Tailored vocal frequency response with brightened midrange and bass roll-off',
      'Uniform cardioid polar pattern isolates the main sound source and minimizes background noise',
      'Pneumatic shock-mount system cuts down handling noise',
      'Spherical steel mesh grille with built-in spherical wind and pop filter'
    ],
    whyWeRecommendIt: 'Unlike sensitive condenser mics that pick up barking dogs, traffic, and AC fans, the SM58 captures only your pure vocal tone, making online 1:1 lessons crystal clear.',
    suitableFor: [
      'Vocal students of Indian classical, Western, and contemporary styles',
      'Home practice and 1:1 live online lessons',
      'Stage recitals, acoustic concerts, and public speaking'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=800&q=80',
    badge: 'Industry Standard Vocal Mic',
    rating: 5.0,
    reviewsCount: 5200,
    isPublished: true,
    isFeatured: true,
    isSaremiPick: true,
    createdAt: '2026-01-25T00:00:00.000Z'
  },
  {
    id: 'prod-gear-ath-m20x',
    name: 'Audio-Technica ATH-M20x Professional Studio Monitor Headphones',
    title: 'Audio-Technica ATH-M20x Professional Studio Monitor Headphones',
    slug: 'audio-technica-ath-m20x-headphones',
    type: 'affiliate',
    productType: 'AFFILIATE_PRODUCT',
    brand: 'Audio-Technica',
    category: 'headphones',
    retailer: 'Amazon',
    affiliateUrl: 'https://www.amazon.in/dp/B00HVLUR18',
    price: 4499,
    originalPrice: 7999,
    displayPrice: 4499,
    discountInfo: '44% off',
    currency: 'INR',
    shortDescription: 'Flat-response studio headphones engineered for critical listening and accurate swara detection.',
    description: 'Professional monitor headphones engineered with flat frequency response for pure tone reproduction without artificial bass coloring.',
    fullDescription: 'The ATH-M20x provides accurate audio reproduction across the frequency spectrum. Its circumaural design contours around the ears for sound isolation in loud environments, allowing music students to hear delicate tanpura drone overtones, subtle vocal pitch variations, and clean metronome beats.',
    keyFeatures: [
      'Advanced 40mm drivers with rare earth magnets and copper-clad aluminum wire voice coils',
      'Tuned for enhanced low-frequency performance with flat, truthful response',
      'Circumaural design contours around ears for excellent sound isolation',
      'Convenient single-side cable exit for comfortable practice sessions'
    ],
    whyWeRecommendIt: 'Consumer headphones artificially boost bass, masking pitch inaccuracies. The ATH-M20x provides the honest, flat sound necessary for ear training and online music lessons.',
    suitableFor: [
      'Critical ear training and microtonal shruti listening',
      'Online 1:1 lessons with faculty',
      'Home recording, mixing, and instrument practice'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=800&q=80',
    badge: 'Accurate Sound Monitoring',
    rating: 4.8,
    reviewsCount: 2900,
    isPublished: true,
    isFeatured: true,
    isSaremiPick: true,
    createdAt: '2026-01-26T00:00:00.000Z'
  },
  {
    id: 'prod-gear-focusrite-solo',
    name: 'Focusrite Scarlett Solo 4th Gen USB Audio Interface',
    title: 'Focusrite Scarlett Solo 4th Gen USB Audio Interface',
    slug: 'focusrite-scarlett-solo-4th-gen',
    type: 'affiliate',
    productType: 'AFFILIATE_PRODUCT',
    brand: 'Focusrite',
    category: 'audio_interfaces',
    retailer: 'Amazon',
    affiliateUrl: 'https://www.amazon.in/dp/B0C6W8H6X7',
    price: 11299,
    originalPrice: 13999,
    displayPrice: 11299,
    discountInfo: '19% off',
    currency: 'INR',
    shortDescription: 'Studio-grade 192kHz/24-bit audio interface with ultra-low-noise mic preamp and Air Mode.',
    description: 'Connect microphones, guitars, and keyboards directly to your computer with pristine studio fidelity for online masterclasses and recording.',
    fullDescription: 'The Scarlett Solo 4th Gen brings professional studio sound to your workspace. Featuring an ultra-low-noise microphone preamp with 69dB gain range, custom-designed headphone amplifier, and re-engineered Air Mode that adds high-end presence and rich harmonic drive to vocals and instruments.',
    keyFeatures: [
      'Ultra-low-noise 4th Gen mic preamp with massive 69dB gain range',
      'Hi-Z instrument input for guitars, keyboards, and acoustic pickups',
      'Air Mode with Presence and Harmonic Drive for console-style depth',
      'Studio-grade 192kHz, 24-bit converters from Focusrite flagship RedNet range'
    ],
    whyWeRecommendIt: 'The simplest, highest-quality audio interface on the market. Eliminates crackling and latency during online classes and records broadcast-quality audio effortlessly.',
    suitableFor: [
      'Home recording of vocals, guitar, violin, flute, and percussion',
      'High-definition audio for online 1:1 lessons and auditions',
      'Music producers and vocalists'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?auto=format&fit=crop&w=800&q=80',
    badge: 'Home Recording Essential',
    rating: 4.9,
    reviewsCount: 1450,
    isPublished: true,
    isFeatured: true,
    isSaremiPick: true,
    createdAt: '2026-01-28T00:00:00.000Z'
  },
  {
    id: 'prod-gear-tabla-set',
    name: 'Maharaja Concert Sheesham Wood Professional Tabla Set (5.5 kg Bayan)',
    title: 'Maharaja Concert Sheesham Wood Professional Tabla Set (5.5 kg Bayan)',
    slug: 'maharaja-concert-sheesham-tabla-set',
    type: 'affiliate',
    productType: 'AFFILIATE_PRODUCT',
    brand: 'Maharaja Musicals',
    category: 'tabla',
    retailer: 'Amazon',
    affiliateUrl: 'https://www.amazon.in/dp/B00938UPOQ',
    price: 14999,
    originalPrice: 18000,
    displayPrice: 14999,
    discountInfo: '17% off',
    currency: 'INR',
    shortDescription: 'Heavy 5.5kg brass Bayan with seasoned Sheesham Dayan and concert-grade goatskin Puri.',
    description: 'Authentic handcrafted concert-grade Tabla pair tuned for rich resonance, deep bass Bayan modulations, and crystalline Dayan pitch sustain.',
    fullDescription: 'Crafted by master instrument artisans in India, this concert tabla set features a seasoned heavy Sheesham wood Dayan tuned to C#/D with high-grade hand-stretched goat skin heads and pure iron-dust Syahi. The Bayan weighs 5.5 kg in solid brass to deliver profound, sustained bass glides.',
    keyFeatures: [
      'Heavy 5.5 kg solid brass Bayan for deep meend pitch modulation and sustained resonance',
      'Seasoned natural Sheesham wood Dayan (standard C# / D concert tuning)',
      'Authentic multilayered Puri heads with high-density iron-dust Syahi',
      'Includes padded gig bag, tuning hammer (hathori), and heavy velvet ring pads (bira)'
    ],
    whyWeRecommendIt: 'A genuine heavy bayan is essential for proper left-hand pressure glide technique. This Maharaja concert set is praised by academy maestros for tonal stability and craftsmanship.',
    suitableFor: [
      'Dedicated tabla learners and classical accompanists',
      'Riyaaz and classical concert performances',
      'Traditional Indian classical music institutions'
    ],
    imageUrl: 'https://images.unsplash.com/photo-1511192336575-5a79af67a629?auto=format&fit=crop&w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1511192336575-5a79af67a629?auto=format&fit=crop&w=800&q=80',
    badge: 'Authentic Concert Grade',
    rating: 4.8,
    reviewsCount: 420,
    isPublished: true,
    isFeatured: true,
    isSaremiPick: true,
    createdAt: '2026-01-30T00:00:00.000Z'
  }
];

export const TESTIMONIALS = [
  {
    id: 'test-1',
    name: 'Dr. Ananya Sen',
    role: 'Parent of 10-year-old Piano Learner, Boston',
    quote: 'My daughter’s teacher Julian notices the subtlest tension in her left wrist via camera and rectifies it immediately. She practiced for years with apps and got frustrated; with 1:1 Saremi classes, she has already prepared for her Grade 2 exam with absolute joy.',
    instrument: 'Piano',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=300&q=80',
    rating: 5
  },
  {
    id: 'test-2',
    name: 'Vikram Mehta',
    role: 'Adult Learner, Hindustani Vocal, London',
    quote: 'Finding a genuine classical guru while living abroad felt impossible. Saremi Academy connected me with Vidushi Sunanda. The clarity of swara instruction and the discipline of Kharaj riyaaz have transformed not just my singing, but my daily peace of mind.',
    instrument: 'Hindustani Vocal',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=300&q=80',
    rating: 5
  },
  {
    id: 'test-3',
    name: 'Sarah Lindqvist',
    role: 'Acoustic Fingerstyle Learner, Seattle',
    quote: 'The storefront and the class platform being unified is brilliant. I ordered the brass capo and practice journal, and they arrived in days. Having my teacher review my weekly practice log right inside the portal keeps me completely accountable.',
    instrument: 'Guitar',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=300&q=80',
    rating: 5
  },
  {
    id: 'test-4',
    name: 'Kabir & Meera Roy',
    role: 'Tabla & Vocal Learners, Singapore',
    quote: 'The real-time order tracking and trial booking were effortless. My son is learning Teentaal bols on the tabla while my daughter studies Carnatic vocal. The teachers are world-class musicians who actually know how to teach children with kindness.',
    instrument: 'Tabla',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=300&q=80',
    rating: 5
  }
];

export const initialTestimonials = TESTIMONIALS;
